import React from 'react';
import Panel from '../../../../components/outline/Panel';
import BrandExposureSelectorHeader from '../BrandExposureSelectorHeader';
import BrandExposureSelectorList from '../BrandExposureSelectorList';

const BrandExposureSelectorSection = (props) => {
  const {
    brandExposureList,
    brandExposureSelector,
    setData,
    searchBrandExposureSelectorList,
    resetBrandExposureSelectorList,
    addBrandExposureListItem,
    selectSelectorItem,
    checkIsDuplicateOnExposureList,
    addSelectedItemToList,
  } = props;

  return (
    <Panel className="brand-tier-selector-section">
      {/*브랜드 셀렉터 헤더 */}
      <BrandExposureSelectorHeader
        brandExposureList={brandExposureList}
        brandExposureSelector={brandExposureSelector}
        setData={setData}
        searchBrandExposureSelectorList={searchBrandExposureSelectorList}
        resetBrandExposureSelectorList={resetBrandExposureSelectorList}
        addSelectedItemToList={addSelectedItemToList}
      />

      {/*브랜드 셀렉터 리스트*/}
      <BrandExposureSelectorList
        brandExposureList={brandExposureList}
        brandExposureSelector={{
          list: brandExposureSelector.list,
          selectedList: brandExposureSelector.selectedList,
        }}
        setData={setData}
        addBrandExposureListItem={addBrandExposureListItem}
        selectSelectorItem={selectSelectorItem}
        checkIsDuplicateOnExposureList={checkIsDuplicateOnExposureList}
      />
    </Panel>
  );
};

export default BrandExposureSelectorSection;
